export default "__VITE_ASSET__BjooIOJB__"